import React, { FC } from 'react';

import HowBrandWorks from '@rover/components/src/HowBrandWorks';
import {
  PageSectionId,
  useSectionRef,
} from '@rover/react-lib/src/pages/landing/SeoLocation/hooks/useSectionRef';
import { PetType } from '@rover/types/src/Pet';

// The shared HowBrandWorksSection speaks in sitters and meet-and-greets, which grooming
// does not do. Grooming is dog-only, so the copy and the images are fixed rather than
// varying with the payload's pet type.
const GroomingHowBrandWorks: FC = () => {
  const sectionRef = useSectionRef(PageSectionId.HowBrandWorks);

  // DEV-156190: Translate
  const steps = [
    {
      heading: `Search`,
      content: `Read reviews and choose a groomer who’s a great match for you and your dog.`,
    },
    {
      heading: `Chat with groomers`,
      content: `Talk about your dog's grooming needs and find a time that works for you.`,
    },
    {
      heading: `Book grooming sessions`,
      content: `All payments use Rover's secured platform and bookings are backed by the Rover Guarantee.`,
    },
  ];

  return (
    <HowBrandWorks htmlRef={sectionRef}>
      {/* Design sizes this heading at heading_600, one step above the shared default. */}
      <HowBrandWorks.Display variant="heading" size="600">
        {/* DEV-156190: Translate */}
        How dog grooming on Rover works
      </HowBrandWorks.Display>
      <HowBrandWorks.List petType={PetType.DOG}>
        {steps.map(({ heading, content }, index) => (
          <HowBrandWorks.ListItem key={heading}>
            <HowBrandWorks.ItemHeading step={index + 1}>{heading}</HowBrandWorks.ItemHeading>
            <HowBrandWorks.ItemContent>{content}</HowBrandWorks.ItemContent>
          </HowBrandWorks.ListItem>
        ))}
      </HowBrandWorks.List>
    </HowBrandWorks>
  );
};

export default GroomingHowBrandWorks;
